module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row categoria-indicadores"
  }, [_c('h3', {
    staticClass: "titulo"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.listaFiltrada, 'label')), function(registro) {
    return _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [(_vm.idioma === 'DE') ? _c('span', {
      staticClass: "info-box-text-legenda"
    }, [_vm._v(_vm._s(registro.labelDe))]) : (_vm.idioma === 'EN') ? _c('span', {
      staticClass: "info-box-text-legenda"
    }, [_vm._v(_vm._s(registro.labelEn))]) : (_vm.idioma === 'ES') ? _c('span', {
      staticClass: "info-box-text-legenda"
    }, [_vm._v(_vm._s(registro.labelEs))]) : _c('span', {
      staticClass: "info-box-text-legenda"
    }, [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + "\n          "), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n          " + _vm._s(registro.data_atualizacao) + "\n        ")])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58672dc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/CategoriaIndicadores.vue
// module id = 682
// module chunks = 1